export default __webpack_public_path__ + "static/slide-3-fd867ccc8b2e52f22256944010fe6329.png";